import React from "react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppButton } from "./WhatsAppButton";

export const Layout = ({ children, mainClassName = "" }) => (
  <div className="font-body min-h-screen flex flex-col bg-cream">
    <Header />
    <main className={`flex-1 overflow-x-hidden ${mainClassName}`}>
      {children}
    </main>
    <Footer />
    <WhatsAppButton />
  </div>
);

export default Layout;
